import React, { useState, useEffect } from 'react';
import { requestForToken, onMessageListener } from '../firebase-config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Notification = () => {
  const [notification, setNotification] = useState({ title: '', body: '' });

  useEffect(() => {
    requestForToken();

    onMessageListener()
      .then((payload) => {
        const title = payload?.notification?.title;
        const body = payload?.notification?.body;

        setNotification({ title, body });

        toast(<ToastDisplay title={title} body={body} />, {
          autoClose: false,         // ✅ This disables auto-close
          closeOnClick: false,
          closeButton: true,
          draggable: false,
        });
      })
      .catch((err) => console.log('Notification listener error: ', err));
  }, []);

  const ToastDisplay = ({ title, body }) => (
    <div>
      <strong>{title}</strong>
      <p>{body}</p>
    </div>
  );

  return <ToastContainer />;
};

export default Notification;
